module.exports = __webpack_public_path__ + "static/media/tapbrick-4.0704c01c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tapbrick-4.jpg
// module id = 112
// module chunks = 0